import { getSpecificAddonGroupsWithOrderDetail } from '@cart-services/utils/get-specific-addon-groups-with-order-detail'
import { type ShippingLabelProvider, type OrderItem } from '@hooks-api/types/dataModel/fpOrder'
import { type WpSubshipSetting } from '@hooks-api/types/dataModel/wp'
import Collapse from '@mui/material/Collapse'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CollapseIcon } from '../shared/CollapseIcon'
import { useContextOrderDetail } from '../shared/OrderDetailProvider/OrderDetailProvider'
import { ShipmentOrderItem } from '../shared/Orders/ShipmentOrderItem'
import { ShippingLabel } from '../shared/Orders/ShippingLabel'

interface ShipmentOrderFastpassProps {
  shippingLabelProviders: ShippingLabelProvider[]
  subshipType?: WpSubshipSetting['type']
  orderItems: OrderItem[]
}

export function ShipmentOrderFastpass({ shippingLabelProviders, subshipType, orderItems }: ShipmentOrderFastpassProps) {
  const { t } = useTranslation()
  const { isWarehouseOrSubscription } = useContextOrderDetail()
  const [open, setOpen] = useState(false)
  const handleChangeOpen = () => {
    setOpen(!open)
  }

  const productItems = orderItems.filter(item => item.order_item_type === 'product')
  const productOrderItems = productItems.filter(item => item.addon_main_product_id === null)
  const specificAddonOrderItems = getSpecificAddonGroupsWithOrderDetail(productItems.filter(item => item.addon_main_product_id !== null))

  const hasMultipleOrderItems = productOrderItems?.length > 1
  return (
    <VStack gap={3}>
      {isWarehouseOrSubscription
        ? productOrderItems.map(orderItem => <ShipmentOrderItem key={orderItem.id} orderItem={orderItem} subshipType={subshipType} specificAddonOrderItems={specificAddonOrderItems[orderItem.variation_id ?? NaN]} />)
        : productOrderItems.slice(0, 1).map(orderItem => <ShipmentOrderItem key={orderItem.id} orderItem={orderItem} subshipType={subshipType} specificAddonOrderItems={specificAddonOrderItems[orderItem.variation_id ?? NaN]} />)}
      <VStack gap={hasMultipleOrderItems && open ? 3 : 0}>
        {hasMultipleOrderItems
        && (
          <Collapse in={open}>
            <VStack gap={3}>
              {!isWarehouseOrSubscription
              && productOrderItems.slice(1).map(orderItem => <ShipmentOrderItem key={orderItem.id} orderItem={orderItem} subshipType={subshipType} specificAddonOrderItems={specificAddonOrderItems[orderItem.variation_id ?? NaN]} />)}
            </VStack>
          </Collapse>
        )}
        {!isWarehouseOrSubscription && <ShippingLabel shippingLabel={shippingLabelProviders} />}
      </VStack>
      {hasMultipleOrderItems && !isWarehouseOrSubscription
      && (
        <Box display="flex" mt={3} justifyContent="center">
          <Button variant="text" onClick={handleChangeOpen}>
            <HStack gap={1} alignItems="center" justifyContent="center">
              <Text variant="body" color={colors.grey500}>
                {open ? t('orderDetail.collapseAll', { defaultValue: '收合全部' }) : t('orderDetail.expandAll', { defaultValue: '展開全部' })}
              </Text>
              <CollapseIcon open={open} color={colors.grey500} />
            </HStack>
          </Button>
        </Box>
      )}
    </VStack>
  )
}
